import {React, Redirect, withRouter} from '@api';
import {shortener} from '@api/graphql';
import {LoadingIndicator} from '@modules';
import {observable} from 'mobx';
import {observer} from 'mobx-react';
import {Route, RouteComponentProps, Switch} from 'react-router';
import * as css from './ShortUrlRedirector.css'

@(withRouter as any)
@observer
export class ShortUrlRedirector extends React.Component<Partial<RouteComponentProps<{short}>>> {
  render() {
      const {longUrl, invalid, props: {match}} = this
      console.log(longUrl, match)

    if (longUrl) {
      return <Redirect to={longUrl} />
    }

    return <div className={css.root}>
      {invalid ? 'Invalid url' : !longUrl ? <LoadingIndicator /> : longUrl}
    </div>
  }

  @observable longUrl = null
  @observable invalid = false
  async componentDidMount() {
    try {
      const {props: {match}} = this
      this.longUrl = await shortener.lookupLongUrl(match.params.short)
    }
    catch (err) {
      console.error(err)
      this.invalid = true
    }
  }
}


// WEBPACK FOOTER //
// ./src/ShortUrlRedirector.tsx